'use strict';

var $ = require('jquery');
var CookiesWrapper = require('../cookie');

/**
 * @description Updates the privacy setting (privacy cookie and session variables)
 */
function updatePrivacySetting() {
    var $cookieInputs = $('.cookie-privacy-detail').find('input[data-cookiename]');
    var $levelInputs = $('.cookie-privacy-detail').find('input[data-privacylevel]:not([data-cookiename])');
    var cookieData = {disallow: [], allow: [], levels: []};

    if ($cookieInputs.length) {
        $cookieInputs.each(function () {
            var $this = $(this);
            cookieData[$this.is(':checked') ? 'allow' : 'disallow'].push($this.data('cookiename'));
        });

        $levelInputs.each(function () {
            var $this = $(this);

            if ($this.is(':checked')) {
                cookieData.levels.push('level' + $this.data('privacylevel'));
            }
        });

        cookieData.disallow = cookieData.disallow.join(',');
        cookieData.allow = cookieData.allow.join(',');
        cookieData.levels = cookieData.levels.join(',');

        $.ajax({
            type: 'POST',
            url: Urls.updatePrivacyCookie,
            data: cookieData,
            success: () => $('body').trigger('privacy::privacySettingsUpdated')
        });
    }
}

function updateOptanonPrivacySetting() {
    let OptanonConsent = CookiesWrapper.get('OptanonConsent');
    if (OptanonConsent && OptanonConsent.length) {
        $.ajax({
            type: 'POST',
            url: Urls.updatePrivacyCookie,
            data: 'OptanonConsent=' + OptanonConsent.slice(OptanonConsent.indexOf('groups'))
        });
        window.location.reload();
    }
}

function setPrivacyLevelsOneTrust() {
    if (window.OneTrust) {
        if (!sessionStorage.getItem('californiaCookieValuesSet')) {
            updateOptanonPrivacySetting();
            sessionStorage.setItem('californiaCookieValuesSet', 'true');
        }
        $(window).on('OneTrustGroupsUpdated', e => {
            updateOptanonPrivacySetting();
        });
    }
}

function getSettings(type) {
    var settingsString = CookiesWrapper.get(type);

    if (settingsString) {
        return settingsString.split('|');
    }

    return null;
}

/**
 * @description Returns an array that contains all disallowed cookies and levels
 */
function getPrivacySettings() {
    return getSettings('privacy_settings');
}

function getPrivacyLevels() {
    var privacyLevel = getSettings('privacy_level');

    if (privacyLevel !== null) {
        return getSettings('privacy_level')
            .map(function (val, index) {
                return val === 'off' ? null : index + 2;
            })
            .filter(function (val) {
                return val != undefined;
            });
    }

    return null;
}

/**
 * @description Initialize the privacy switches and set the actual setting from the privacy cookie
 */
function initPrivacySwitches() {
    var $switches = $('.privacy .privacy-switch');
    var $cookieSwitch = $('.privacy input[data-cookiename]');
    var $levelSwitch = $('.privacy input[data-privacylevel]:not([data-cookiename])');
    var privacySettings = getPrivacySettings();
    var privacyLevels = getPrivacyLevels();

    $switches.each(function () {
        var $privacySwitch = $(this);

        if ($privacySwitch.find('.locked').length === 0) {
            var cookieName = $privacySwitch.data('cookiename') || null;
            var privacyLevel = $privacySwitch.data('privacylevel') || null;
            var active = true;

            if (cookieName !== null && privacySettings !== null) {
                active = !(privacySettings.indexOf(cookieName) > -1);
                $privacySwitch.find('input').prop('checked', active);
            } else if (privacyLevel !== null && privacyLevels !== null) {
                active = privacyLevels.indexOf(privacyLevel) > -1;
                $privacySwitch.find('input').prop('checked', active);
            }
        }
    });

    $levelSwitch.on('change', function (event) {
        var $this = $(this);
        var $element = $('.privacy input[data-privacylevel="' + $this.data('privacylevel') + '"]:not(:disabled)');

        $element.prop('checked', $this.is(':checked'));
    });

    $cookieSwitch.on('change', function (event) {
        var $this = $(this);
        var $levelSwitches = $(
            '.privacy input[data-privacylevel="' +
                $this.data('privacylevel') +
                '"]:not([data-cookiename]):not(:disabled)'
        );

        if ($this.is(':checked')) {
            $levelSwitches.prop('checked', true);
        } else {
            var $levelCookieSwitches = $(
                '.privacy input[data-privacylevel="' + $this.data('privacylevel') + '"][data-cookiename]:not(:disabled)'
            );
            var active =
                $levelCookieSwitches.filter(function () {
                    return $(this).is(':checked');
                }).length > 0;

            $levelSwitches.prop('checked', active);
        }
    });

    $switches.find('.switch:not(.locked) input').on('change', updatePrivacySetting);
}

module.exports.initPrivacySwitches = initPrivacySwitches;
module.exports.getPrivacySettings = getPrivacySettings;
module.exports.getPrivacyLevels = getPrivacyLevels;
module.exports.setPrivacyLevelsOneTrust = setPrivacyLevelsOneTrust;
